import { render, staticRenderFns } from "./SelectAutoComplete.vue?vue&type=template&id=489a4208&scoped=true"
import script from "./SelectAutoComplete.vue?vue&type=script&lang=js"
export * from "./SelectAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a4208",
  null
  
)

export default component.exports